import axios from 'axios';
// import Auth from '../plugins/Auth'
import Vue from 'vue'

var UrlPlugin={
    getUrl:function(){
        // return 'http://192.168.0.5:8000/';
        // return 'http://192.168.2.7/';
        // return 'http://192.129.78.107/';
    },
    setHeaders:function(token=''){
        
        let config='';
        if(token===null){
            config = {
                headers:{
                    'Content-Type': 'application/json'
                }
            };
        }else{
            config = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+token
                }
            };
        }
        return config;
    }
};

export default function(Vue){

    Vue.urlP=UrlPlugin;

    Object.defineProperties(Vue.prototype, {
        $urlP:{
            get:function(){
                return Vue.urlP;
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/plugins/Url.js